export default __webpack_public_path__ + "static/media/03.afbb32c2.webp";